import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Recorder } from "./recorder";
import { uploadVideo } from "./helper";
import { useUser } from "../../../hooks/useUser";

export const Introduction = () => {
  const [video, setVideo] = useState(null);
  const navigate = useNavigate();
  const { user } = useUser();

  const onSubmit = async () => {
    const shouldNavigate = await uploadVideo(video, "video1");
    if (shouldNavigate) {
      if (user.video2 === "") {
        navigate("/pro/recording/additional-info");
      } else {
        navigate("/settings/intro-videos");
      }
    }
  };

  const props = {
    allowManualSubmission: true,
    setVideo,
    onSubmit: video ? onSubmit : null,
  };

  return (
    <Recorder
      {...props}
      heading="Introduction"
      body="Please introduce yourself, including your name, age, profession, and years of experience. Share what you love most about your profession."
    />
  );
};
